import { IRoad } from '../../types/geo';
import { IThunkActionCreator } from '../../types/store';
import { trackRoadsSearchEmpty } from '../../components/roads/tracking';
import { DEFAULT_ROAD_DISTANCE, SavedFiltersIds } from '../../interfaces/filters';
import { isArrayWithItems } from '../../utils';
import { getRoadDistanceLabel } from '../../utils/filters_helpers';
import { getRoadFullName, normalizeNameForSearch, roadTypes } from '../../utils/geo';
import { getRoadsModels } from '../../utils/roads';
import { showCommutePopup } from '../commute_popup/actions';
import { changePage, changeRoadDistance, IFilterRegionChanged } from '../filters/actions';
import { addSavedFilter } from '../saved_filters/actions';
import { trackSubmitClicked } from '../../components/commute_popup/tracking';
import { filterRoads } from './filterRoads';
import { selectRoads } from './selectRoads';

export interface IRoadsFetched {
  type: 'RoadsFetched';
  roads: IRoad[];
}

export interface IRoadsPopupDistanceChanged {
  type: 'RoadsPopupDistanceChanged';
  value: number;
}

export interface IRoadsPopupSelectedRoadsChanged {
  type: 'RoadsPopupSelectedRoadsChanged';
  value: number[];
}

export const changePopupRoadDistance = (value: number): IRoadsPopupDistanceChanged => ({
  type: 'RoadsPopupDistanceChanged',
  value,
});

export const changePopupSelectedRoads = (value: number[]): IRoadsPopupSelectedRoadsChanged => ({
  type: 'RoadsPopupSelectedRoadsChanged',
  value,
});

export const onFiltersChanged =
  (roadDistance?: number | null, road?: number[] | null): IThunkActionCreator =>
  dispatch => {
    dispatch(changePopupRoadDistance(roadDistance || DEFAULT_ROAD_DISTANCE));
    dispatch(changePopupSelectedRoads(road || []));
  };

export const onChangeRoadDistance =
  (value = DEFAULT_ROAD_DISTANCE, save = true): IThunkActionCreator =>
  dispatch => {
    dispatch(
      addSavedFilter({
        id: SavedFiltersIds.RoadDistance,
        name: getRoadDistanceLabel(value),
        value,
      }),
    );
    dispatch(changeRoadDistance(value));
    if (save) {
      dispatch(changePage(1));
    }
  };

export const onRoadsPopupAccept = (): IThunkActionCreator => (dispatch, getState) => {
  const { roads } = getState();
  const { selectedRoads, roadDistance } = roads;
  if (selectedRoads.length) {
    trackSubmitClicked('highway_save', selectedRoads.length);
  }
  dispatch(showCommutePopup(false));
  dispatch(selectRoads(getRoadsModels(roads), false, roadDistance));
};

export interface IRoadsFiltered {
  type: 'RoadsFiltered';
  roads: IRoad[];
}

export const getRoadNameVariants = (road: IRoad): string[] =>
  roadTypes
    .reduce((acc, value) => acc.concat(`${value} ${road.name}`, `${road.name} ${value}`), [getRoadFullName(road)])
    .map(normalizeNameForSearch);

export function filterPopupRoads(
  value: string,
  distance: number = DEFAULT_ROAD_DISTANCE,
  trackNotFound: boolean = false,
): IThunkActionCreator {
  return (dispatch, getState) => {
    dispatch(filterRoads(value, distance));

    if (trackNotFound) {
      const {
        roads: { suggests },
      } = getState();
      if (!isArrayWithItems(suggests)) {
        trackRoadsSearchEmpty();
      }
    }
  };
}

export function changeSubroads(ids: number[], checked: boolean = true): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      roads: { selectedRoads },
    } = getState();
    const nextSelectedRoads = checked ? selectedRoads.concat(ids) : selectedRoads.filter(id => !ids.includes(id));
    dispatch(changePopupSelectedRoads(nextSelectedRoads));
  };
}

export type Action =
  IFilterRegionChanged | IRoadsFetched | IRoadsFiltered | IRoadsPopupDistanceChanged | IRoadsPopupSelectedRoadsChanged;
